export var bottom = 'SO-Iv';
export var bottomReverse = 'p2EbW';
export var middle = 'XZjFx';
export var paused = 'R3mz-';
export var top = 'QTl-V';
export var topReverse = 'hmiOP';